import React, { useState, useRef, useEffect } from 'react';
import Grid from '../layout/grid';
import Select, { components } from 'react-select';

export default props =>  {

	const customStyles = {
		menuPortal: base => ({ ...base, zIndex: 9999 })
	};

	return (
		<Select
			styles={customStyles}
			defaultValue={props.value ? (props.options || []).map(opt => ({ value: String(opt.id), label: opt.valor })).filter(opt => opt.value == props.value)[0] || null : null}
			isClearable={props.permiteLimpar}
			isSearchable={true}
			isDisabled={props.readOnly ? true : false}
			onChange={(item) => props.onChange(item ? item.value : null)}
			options={(props.options || []).map(opt => ({ value: opt.id, label: opt.valor }))} 
			menuPortalTarget={document.body} />
	)
}